import { usePermissions } from '@/hooks/use-permission.ts';
import type { RangeGranularity } from '@/utils/granularity.ts';

const GRANULARITY_ACTIONS = [
  '1min',
  '5min',
  '15min',
  'hourly',
  'daily',
  'monthly',
] as const satisfies readonly RangeGranularity[];

export const useGranularityPermissions = (): RangeGranularity[] => {
  const results = usePermissions(
    GRANULARITY_ACTIONS.map(
      (g) =>
        ['date-range-picker', `view-granularity.${g}`] as [
          'date-range-picker',
          `view-granularity.${typeof g}`,
        ]
    )
  );

  return GRANULARITY_ACTIONS.filter((_, i) => !results[i]);
};
